import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useSpring, animated } from '@react-spring/web';

interface Props {
    transformInView: string;
    transformOutView: string;
}

const FadeAnimation: React.FC<Props> = ({ children, transformInView, transformOutView }) => {
    const { ref, inView } = useInView({ threshold: 0.2, triggerOnce: true });

    const spring = useSpring({
        opacity: inView ? 1 : 0,
        transform: inView ? transformInView : transformOutView,
        config: { mass: 1, tension: 200, friction: 70 }
    });

    return (
        <animated.div ref={ref} style={spring}>
            {children}
        </animated.div>
    );
};

export default FadeAnimation;
